import { BIM360IssueActivityV2, IssueActivity, QualityIssueEdit, ChangedObject} from '../BIM360IssueActivityV2';

export class FrontendBIM360IssueActivityV2 extends BIM360IssueActivityV2{
    constructor(json:any)
    {
        super();
        this.id = json.id;
        this.submitted = json.submitted;
        this.activity = new IssueActivity(json.activity);
    }

    public objectHasProperty(key: string)
    {
        if(this.activity.object.hasOwnProperty(key) && this.activity.object[key])
        {
            return true;    
        }
        return false;
    }

    get object()
    {
        return this.activity.object;
    }

    get type()
    {
        return this.activity.verb
    }

    get changedCustomAttributes()
    {
        if(this.activity.object instanceof QualityIssueEdit && this.activity.object.changed_custom_attributes)
        {
            return {
                id: this.activity.object.changed_custom_attributes.id,
                displayName: this.activity.object.changed_custom_attributes.displayName,
                property: this.activity.object.changed_custom_attributes.property,
                before: JSON.parse(this.activity.object.changed_custom_attributes.before),
                after: JSON.parse(this.activity.object.changed_custom_attributes.after),
            }
        }
        return null;
    }

    public getChanges()
    {
        const changes:ChangedObject[] = [];
        const keys = Object.keys(this.object);
        const keysForChanges = keys.filter(key => key.includes('changed_'));
        for(const k of keysForChanges)
        {
            if(this.object[k])
            {
                let value = this.object[k]
                if(k == 'changed_custom_attributes')
                {
                    value = this.changedCustomAttributes;
                }
                changes.push(value)
            }
        }
        return changes;
    }
}
